var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 117.71 117.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ca5ad;}.cls-2{fill:#505050;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.71,34.27v75.57a7.54,7.54,0,0,1-7.52,7.52H7.52A7.54,7.54,0,0,1,0,109.84V34.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,34.52V17.69a7.54,7.54,0,0,1,7.52-7.52H110.19a7.54,7.54,0,0,1,7.52,7.52V34.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.87,100H35a2.66,2.66,0,0,0,2.67-2.67V83.22A2.67,2.67,0,0,0,35,80.54H20.87a2.68,2.68,0,0,0-2.68,2.68V97.31A2.67,2.67,0,0,0,20.87,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.81,71.09H65.9a2.67,2.67,0,0,0,2.67-2.68V54.32a2.67,2.67,0,0,0-2.67-2.68H51.81a2.68,2.68,0,0,0-2.68,2.68V68.41A2.68,2.68,0,0,0,51.81,71.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.87,71.09H35a2.67,2.67,0,0,0,2.67-2.68V54.32A2.67,2.67,0,0,0,35,51.64H20.87a2.68,2.68,0,0,0-2.68,2.68V68.41A2.68,2.68,0,0,0,20.87,71.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.81,100H65.9a2.66,2.66,0,0,0,2.67-2.67V83.22a2.67,2.67,0,0,0-2.67-2.68H51.81a2.68,2.68,0,0,0-2.68,2.68V97.31A2.67,2.67,0,0,0,51.81,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.75,71.09H96.84a2.67,2.67,0,0,0,2.67-2.68V54.32a2.67,2.67,0,0,0-2.67-2.68H82.75a2.68,2.68,0,0,0-2.68,2.68V68.41A2.68,2.68,0,0,0,82.75,71.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.75,100H96.84a2.66,2.66,0,0,0,2.67-2.67V83.22a2.67,2.67,0,0,0-2.67-2.68H82.75a2.68,2.68,0,0,0-2.68,2.68V97.31A2.67,2.67,0,0,0,82.75,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.9,13.58V5.45A5.46,5.46,0,0,0,88,5.45V19.19a5.46,5.46,0,1,0,10.91,0V13.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.71,13.58V5.45a5.46,5.46,0,0,0-10.91,0V19.19a5.46,5.46,0,1,0,10.91,0V13.58Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.56b3d345c88aeeceeb08f0d16117aa9f.svg";
export { ForwardRef as ReactComponent };